<app-title-bar rootBreadCrumbs="['i18n.core.navigation.admin']" titleText="i18n.domain.administration.title"></app-title-bar>
<div class="row">
  <div class="col">
    <div  class="d-flex align-items-center mb-2">
      @if (!isClientAdminView) {
        <label class="me-2">{{ 'i18n.base.shared.client-dropdown.client' | translate }}:</label>
      }
      <app-client-autocomplete [(selectedClient)]="selectedClient" class="client-autocomplete"></app-client-autocomplete>
    </div>
  </div>
</div>
@if (selectedClient) {
  <div class="content-wrapper">
    <div class="header">

    </div>
    <div class="content">
      <div class="left">
        <div class="mode-switch">
            <app-yes-no-group-button yesLabel='i18n.domain.administration.overview.zone-based' noLabel='i18n.domain.administration.overview.config-based' [formControl]="isZoneModeControl"></app-yes-no-group-button>
        </div>
        @if (isZoneModeControl.value) {
          <app-tree-view-zone-based [hasPendingDetailChanges]="hasPendingDetailChanges" (itemSelected)="onItemSelected($event)"></app-tree-view-zone-based>
        } @else {
          <app-tree-view-config-based [hasPendingDetailChanges]="hasPendingDetailChanges" (itemSelected)="onItemSelected($event)"></app-tree-view-config-based>
        }
      </div>
      <div class="right">
        <app-administration-details [selectedItem]="selectedItem"
                                    (cancel)="onDetailCancel()"
                                    (itemCreated)="onItemCreated($event)"
                                    (itemUpdated)="onItemUpdated($event)"
                                    (itemDeleted)="onItemDeleted($event)"
                                    (hasPendingDetailChangesChanged)="onHasPendingDetailChanges($event)"></app-administration-details>
      </div>
    </div>
  </div>
}
